import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { DriverDocumentsPage } from 'routes/paths';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { ReactComponent as NotificationIcon } from '../../../../assets/images/notification.svg';
import requestService from '../../../../store/request/service';
import { LoaderArrow } from '../../../../components/Loaders/LoaderArrow';
import { useGetCandidateDocumentList } from '../useGetCandidateDocumentList';

export interface ITemporaryLicensePageProps {
  className?: string;
}

function TemporaryLicensePage(props: ITemporaryLicensePageProps) {
  const [isWaiting, setIsWaiting] = useState(false);
  const { documentId } = useParams();

  const navigate = useNavigate();

  const { candidateData, isLoading } = useGetCandidateDocumentList();

  const [candidateMarkDriverLicenseAsWithoutPhoto] =
    requestService.endpoints.candidateMarkDriverLicenseAsWithoutPhoto.useMutation();

  const handleNextClick = async () => {
    setIsWaiting(true);
    if (documentId) {
      await candidateMarkDriverLicenseAsWithoutPhoto({
        candidateDocumentId: documentId,
        containsUserPhoto: false,
      });
      // Don't remove this setTimeout. Only in this case all works
      setTimeout(() => {
        setIsWaiting(false);
        navigate(
          `${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_LICENSE}`
        );
      }, 1000);
      return;
    }
    setIsWaiting(false);
    navigate(`${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_LICENSE}`);
  };

  const handleDocumentHasPhotoClick = async () => {
    if (documentId) {
      await candidateMarkDriverLicenseAsWithoutPhoto({
        candidateDocumentId: documentId,
        containsUserPhoto: true,
      });
      setTimeout(() => {
        navigate(
          `${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_LICENSE}`
        );
      }, 1000);
      return;
    }
    navigate(`${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_LICENSE}`);
  };

  useEffect(() => {
    if (candidateData?.documents?.length) {
      const driverLicense = candidateData.documents.find(
        (doc) => doc.documentType === DocumentTypeEnum.DRIVER_LICENSE
      );
      if (!driverLicense || driverLicense?.containsUserPhoto) {
        navigate(
          `${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_LICENSE}`
        );
      }
    }
  }, [candidateData?.documents]);

  if (isLoading || isWaiting) {
    return <LoaderArrow />;
  }

  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.image}>
        <NotificationIcon />
      </div>

      <h3>Missing Photo</h3>
      <div className={styles.subtitle}>
        We could not detect a facial photo in your license. You will need to
        submit an additional Photo ID on the next step.
      </div>

      <div className={styles.actions}>
        <ButtonWithArrowIcon type="button" onClick={handleNextClick}>
          Next
        </ButtonWithArrowIcon>
        <div className={styles.link}>
          <span onClick={handleDocumentHasPhotoClick}>
            There is a photo in my license
          </span>
        </div>
      </div>
    </div>
  );
}

export default TemporaryLicensePage;
